@if (loading()) {
  <mat-progress-bar mode="indeterminate" />
}
